// extracted by mini-css-extract-plugin
module.exports = {"resultRow":"MultipleChoiceVotesList_resultRow__2pcKP","optionName":"MultipleChoiceVotesList_optionName__vuMSB","votes":"MultipleChoiceVotesList_votes__aVWzY"};